import dayjs from 'dayjs';
import { List, ListItemButton } from '@mui/material';
import AttIcon from './AttIcon';
import AttLineChart from './AttLineChart';
import AttSumChart from './AttSumChart';

function getMjesec(datum) {
  if (!datum) return '';
  const m = dayjs(datum).format('MMM');
  if (m === 'May') return 'Maj';
  if (m === 'Oct') return 'Okt';
  return m;
}

function getDan(datum) {
  if (!datum) return '';
  return dayjs(datum).format('DD');
}

function getTekucaStatistika(attendance) {
  const data = [];
  if (attendance.length > 0) {
    const item = attendance[attendance.length - 1];
    data.push({ name: 'neopravdani', value: item.broj_neopravdanih });
    data.push({ name: 'opravdani', value: item.broj_opravdanih });
  }
  return data;
}

function getUkupnaStatistika(attendance) {
  return attendance.map((item) => ({
    datum: dayjs(item.datum_azuriranja).format('DD.MMM'),
    opravdani: item.broj_opravdanih,
    neopravdani: item.broj_neopravdanih,
  }));
}

export default function Attendance({ attendance = [] }) {
  return (
    <div>
      <div className="marks-layout">
        <div className="marks-layout-left">
          <div className="marks-container">
            <List sx={{ p: 0, m: 0 }}>
              {attendance.map((item, index) => (
                <ListItemButton key={index} sx={{ p: 0, m: 0 }}>
                  <div className="main-flex-container">
                    <AttIcon naziv={item.naziv_perioda} />
                    <div className="right-flex-container">
                      <div className="upper-flex-container">
                        <div className="main-text">{item.naziv_perioda}</div>
                      </div>
                      <div className="bottom-flex-container w-100">
                        <div className="att-stats">
                          <span>{'Broj opravdanih ' + item.broj_opravdanih}</span>
                          <span>{'Broj neopravdanih ' + item.broj_neopravdanih}</span>
                          <span>{'Broj na čekanju ' + item.broj_na_cekanju}</span>
                        </div>
                      </div>
                    </div>
                    <div className="date-container">
                      <div>{getDan(item.datum_azuriranja)}</div>
                      <div>{getMjesec(item.datum_azuriranja)}</div>
                    </div>
                  </div>
                </ListItemButton>
              ))}
            </List>
          </div>
        </div>
        <div className="marks-layout-right">
          <div className="chart-container">
            <AttSumChart data={getTekucaStatistika(attendance)} />
          </div>
          <div className="chart-container chart-container-mt3">
            <AttLineChart data={getUkupnaStatistika(attendance)} />
          </div>
        </div>
      </div>
    </div>
  );
}
